import MonthlySheetDetails from './monthly-sheet-details'

export default MonthlySheetDetails
